import { FETCH_REWARDS, ADD_REWARDS, EDIT_REWARDS, REMOVE_REWARDS } from '../actionTypes';

export const addReward = payload => ({
    type: ADD_REWARDS,
    payload
});

export const editReward = payload => ({
    type: EDIT_REWARDS,
    payload
});

export const fetchRewards = payload => ({
    type: FETCH_REWARDS,
    payload
});

export const removeReward = id => ({
    type: REMOVE_REWARDS,
    id
});